import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b75d3512"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "z-100 bg-white w-screen h-screen" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title w-full text-center" }, " Permitir uso dos dados do seu CNPJ? ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "py-5" }, " Ao aceitar o consentimento os dados vinculados a esse CNPJ vão ser disponibilizados para um novo cadastro no Portal do Cliente Tecnospeed, deseja permitir esta ação? ", -1))
const _hoisted_4 = { class: "flex gap-5 justify-center w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_PrimaryButton = _resolveComponent("PrimaryButton")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Modal, {
      isOpen: true,
      class: "lg:w-2/4 m-auto text-center"
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Button, {
            id: "button",
            class: "w-32",
            label: "Cancelar",
            labelClass: "text-black",
            icon: _ctx.buttonIcon,
            onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.cancel(); _ctx.close_window()})
          }, null, 8, ["icon"]),
          _createVNode(_component_PrimaryButton, {
            id: "button",
            class: "w-32 text-white",
            label: "Permitir",
            icon: _ctx.buttonIcon,
            onClick: _ctx.handleBack
          }, null, 8, ["icon", "onClick"])
        ])
      ]),
      _: 1
    })
  ]))
}